import { Route, Routes } from "react-router-dom";
import ResourceNotFound from "../../../Common/ResourceNotFound";
import SettingsCompanyInfo from "../CompanyInfo/SettingsCompanyInfo";
import SettingsReport from "../SettingsReport";
import SettingOpeningBalanceNew from "../OpeningnClosing/SettingOpeningBalanceNew";
import SettingsTemplates from "../Template/SettingsTemplates";
import { Card } from "antd";
import SettingSecCustomization from "../CompanyInfo/SettingSecCustomization";
import SettingDefaultLedger from "../DefaultLedger/SettingDefaultLedger";
import TermsAndConditions from "../TermsAndCondition/TermsAndConditions";
import TdsList from "../../TcsTds/Tds/TdsList";
import SettingItems from "../Items/SettingItems";
import SettingCurrency from "../Currency/CurrencyTable";
import LockMonth from "../LockMonth/LockMonth";
import { useUser } from "../../../../Context/UserContext";
import { IAccessSettings } from "../../../../Types";
import {
  findUserOnlyOnePremission,
  findUserPremission,
} from "../../Users/Roles/UserSecurityFind";
import { useClient } from "../../../Context/ClientContext";
import { SettingsSections } from "../../../Services/SettingService";
import { IPermissionActionType } from "../../Users/Roles/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../../Context/RoleContext";
import TcsList from "../../TcsTds/Tcs/TcsList";
import SettingsEmail from "../Email/SettingsEmail";
import ClosingEntries from "../OpeningnClosing/ClosingEntry";
// import SettingsNewDashboard from "./SettingsNewDashboard";

const SettingNestedRoute = () => {
  const { currentClient } = useClient();
  const { accessSettings, clientSpecificRole } = useUser();
  const useAccessSettingsData: IAccessSettings = accessSettings();

  return (
    <Card
      size="small"
      className="TableCard"
      style={{
        marginTop: "6px",
        padding: "15px 0px 0px 0px",
        boxShadow: "0px 0px 10px 0px #96A1C84D",
      }}
    >
      <Routes>
        <Route
          path="/companyInfo"
          element={
            findUserPremission(
              [
                "Setting.Company.Info.View",
                "Setting.Company.Details.View",
                "Setting.Company.PaymentTerm.View",
                "Setting.Company.GST.View",
              ],
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              // findUserSettingAccessSecurity(
              //   useAccessSettingsData,
              //   Setting_Type.CompanyInfo
              // ) ?
              <SettingsCompanyInfo />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/vouchers"
          element={
            findUserPremission(
              [
                "Setting.Voucher.1.View",
                "Setting.Voucher.2.View",
                "Setting.Voucher.3.View",
                "Setting.Voucher.5.View",
                "Setting.Voucher.4.View",
                "Setting.Voucher.6.View",

                "Setting.Voucher.7.View",
                "Setting.Voucher.8.View",
                "Setting.Voucher.10.View",
                "Setting.Voucher.9.View",

                "Setting.Voucher.14.View",
                "Setting.Voucher.15.View",

                "Setting.Voucher.13.View",
                "Setting.Voucher.12.View",
                "Setting.Voucher.11.View",
              ],
              clientSpecificRole(),
              currentClient?.id!,
              [
                SettingsSections.Invoice,
                SettingsSections.PInvoice,
                SettingsSections.CrNote,
                SettingsSections.Receipt,
                SettingsSections.Quotation,
                SettingsSections.SOrder,

                // Purchase
                SettingsSections.PurInvoice,
                SettingsSections.DrNote,
                SettingsSections.Payment,
                SettingsSections.POrder,

                // expenses & income
                SettingsSections.Expenses,
                SettingsSections.Income,

                // Journal
                SettingsSections.Journal,
                // Contra
                SettingsSections.Contra,
                // Asset
                SettingsSections.Asset,
              ],
              {
                actionType: IPermissionActionType.View,
                dataType: [ITypeIIsClientSpecificRoleDataType.Setting],
              }
            ) ? (
              <SettingSecCustomization />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/items"
          element={
            findUserOnlyOnePremission(
              "Setting.Item.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <SettingItems />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        {/* <Route path="/paymentTerm" element={<SettingPaymentTerm />} /> */}
        {/* <Route path="/gst" element={<SettingsGst />} /> */}
        <Route
          path="/report"
          element={
            // findUserPremission(
            //   ["Setting.Item.View"],
            //   clientSpecificRole(),
            //   currentClient?.id!
            // ) ? (
            <SettingsReport />
            // ) : (
            //   <ResourceNotFound pageHeight="100%" />
            // )
          }
        />
        <Route
          path="/openingBalance"
          element={
            findUserOnlyOnePremission(
              "Setting.OpeningBalance.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <SettingOpeningBalanceNew />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route path="/closingEntries" element={<ClosingEntries />} />
        <Route
          path="/email"
          element={
            findUserOnlyOnePremission(
              "Setting.Email.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <SettingsEmail />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/templates"
          element={
            findUserOnlyOnePremission(
              "Setting.Templates.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <SettingsTemplates />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        {/* <Route path="/advSetting" element={<SettingsAdvance />} /> */}
        <Route
          path="/termsandConditions"
          element={
            findUserPremission(
              [
                "Setting.TC.1.View",
                "Setting.TC.2.View",
                "Setting.TC.3.View",
                "Setting.TC.5.View",
                "Setting.TC.4.View",
                "Setting.TC.6.View",
                "Setting.TC.7.View",
                "Setting.TC.8.View",
                "Setting.TC.10.View",
                "Setting.TC.9.View",
                "Setting.TC.14.View",
                "Setting.TC.15.View",
                "Setting.TC.13.View",
                "Setting.TC.12.View",
                "Setting.TC.11.View",
              ],
              clientSpecificRole(),
              currentClient?.id!,
              [
                SettingsSections.Invoice,
                SettingsSections.PInvoice,
                SettingsSections.CrNote,
                SettingsSections.Receipt,
                SettingsSections.Quotation,
                SettingsSections.SOrder,

                // Purchase
                SettingsSections.PurInvoice,
                SettingsSections.DrNote,
                SettingsSections.Payment,
                SettingsSections.POrder,

                // expenses & income
                SettingsSections.Expenses,
                SettingsSections.Income,

                // Journal
                SettingsSections.Journal,
                // Contra
                SettingsSections.Contra,
                // Asset
                SettingsSections.Asset,
              ],
              {
                actionType: IPermissionActionType.View,
                dataType: [ITypeIIsClientSpecificRoleDataType.TandC],
              }
            ) ? (
              <TermsAndConditions />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/tds"
          element={
            findUserOnlyOnePremission(
              "Setting.TDS.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <TdsList Role="ADMIN" />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/tcs"
          element={
            findUserOnlyOnePremission(
              "Setting.TCS.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <TcsList Role="ADMIN" />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />

        <Route
          path="/defaultLedger"
          element={
            findUserOnlyOnePremission(
              "Setting.DefaultLedger.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <SettingDefaultLedger />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route
          path="/currencies"
          element={
            findUserOnlyOnePremission(
              "Setting.Currencies.View",
              clientSpecificRole(),
              currentClient?.id!
            ) ? (
              <SettingCurrency />
            ) : (
              <ResourceNotFound pageHeight="100%" />
            )
          }
        />
        <Route path="/lockmonth" element={<LockMonth />} />
        {/* <Route path="/newDashboard" element={<SettingsNewDashboard />} /> */}
        <Route path="*" element={<ResourceNotFound pageHeight="100%" />} />
      </Routes>
    </Card>
  );
};

export default SettingNestedRoute;
